import React from 'react'

import SearchInput from '../../../ui/SearchInput'

import Table from '../../../components/Table'
import topSessionsModel from '../../../tables/topSessionsModel'
import { Header, Box } from '../../../ui/layout'

const TopArtists = (props) => (
  <div>
    <Header>
      <Box paddingX={2} flexGrow={1}>
        <SearchInput />
      </Box>
    </Header>
    <Table model={topSessionsModel} />
  </div>
)

export default TopArtists
